import React from 'react'
import Calendar from './Calendar'
import TicketListContent from './TicketListContent'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Redirect } from 'react-router'
import config from '../config'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import {
  getVehicleNumberByTrackables,
  resultsToUniqueArray,
  getBody
} from '../utils/trackable'
moment.locale('fr')

let d = new Date()
d.setHours(0, 0, 0, 0)

class TicketContentComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedDay: props.data.length > 0 ? new Date() : undefined,
      data: this.updateDataStructure(props.data),
      dataOfSelectedDay: null,
      dataOfMonth: null,
      formattedDateList: null,
      selectedMonth: d,
      dataOfForm: null,
      requirementKey: Math.random(),
      openModal: false,
      idTicket: null
    }
  }

  UNSAFE_componentWillMount () {
    this.getTicketOfSelectedMonth(this.props.route, this.state.selectedMonth)
  }

  componentDidMount () {
    const self = this
    if (self.state.selectedDay && self.state.selectedDay !== undefined) {
      self.getDataOfSelectedDay(self.state.selectedDay, self.props.route)
    }
  }

  getTrackableIds () {
    return this.props.trackableIds 
  }

  updateDataStructure (data) {
    let structuredData = []
    data.forEach(function (element, key) {
      let attr = element.value
      let myElement = {}
      for (let k in attr) {
        if (typeof (attr[k]) === 'object') {
          for (let mykey in attr[k]) {
            let value = attr[k][mykey]
            if (typeof value === 'string' && value !== '') {
              myElement[mykey] = parseFloat(value.replace(/\s/g, ''))
            } else {
              myElement[mykey] = value
            }
          }
        } else {
          if ((k === 'quantity' && attr[k] !== '') ||
           (k === 'discount' && attr[k] !== '') ||
           (k === 'mileage' && attr[k] !== '') ||
           (k === 'liter_for_hundred' && attr[k] !== '') ||
           (k === 'cost_for_hundred' && attr[k] !== '')) {
            myElement[k] = parseFloat(attr[k])
          } else {
            myElement[k] = attr[k]
          }
        }
      }
      structuredData.push(myElement)
    })
    return structuredData
  }

  getDateInData (data) {
    let dateList = []
    data.forEach(function (element) {
      dateList.push(new Date(momentTimezone.utc(element.value.date_time).tz('Indian/Antananarivo')))
    })
    return dateList
  }

  getFormattedDateList (data) {
    let formattedDateList = []
    if (data) {
      data.forEach(function (element) {
        formattedDateList.push(momentTimezone.utc(element.value.date_time).tz('Indian/Antananarivo').format('MM/DD/YYYY'))
      })
    }
    return this.removeDuplicate(formattedDateList)
  }

  removeDuplicate (array) {
    let unique = {}
    array.forEach(function (i) {
      if (!unique[i]) {
        unique[i] = true
      }
    })
    return Object.keys(unique)
  }

  handleDayClick (day, { selected }, formattedDateList) {
    const self = this
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (result) {
        if (result.error && result.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        let formattedDate = moment(day).format('MM/DD/YYYY')
        if (formattedDateList.includes(formattedDate)) {
          self.getDataOfSelectedDay(day, self.props.route)
        }
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  onMonthChange (month) {
    const self = this
    var route = self.props.route
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (data) {
        if (data.error && data.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        self.setState({
          selectedMonth: month
        })
        self.getTicketOfSelectedMonth(route, month)
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  async getAllTicketOfSelectedDay (day) {
    const self = this
    let vehicleNumberList = await getVehicleNumberByTrackables(this.getTrackableIds())
    let selectedDay = day
    let selectedMonth = this.state.selectedMonth
    let myDay
    let myMonth
    let myYear
    let start = new Date()
    let end = new Date()
    if (selectedDay) {
      myDay = selectedDay.getDate()
      myMonth = selectedMonth.getMonth()
      myYear = selectedMonth.getFullYear()
      start = new Date(myYear, myMonth, myDay, 0, 0, 0)
      end = new Date(myYear, myMonth, myDay, 23, 59, 59)
    }
    if (selectedDay) {
      let body = getBody(vehicleNumberList, start.toJSON(), end.toJSON())
      fetch(
        `${config.couchdb_final_docs}AllByVehicleAndDate/queries`, {
          method: 'post',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then((data) => {
          this.setState({
            dataOfSelectedDay: self.updateDataStructure(resultsToUniqueArray(data.results)),
            selectedDay: selectedDay,
            requirementKey: Math.random()
          })
        })
        .catch(error => { console.log(error) })
    }
  }

  async getInprogressTicketOfSelectedDay (day) {
    const self = this
    let vehicleNumberList = await getVehicleNumberByTrackables(this.getTrackableIds())
    let selectedDay = day
    let selectedMonth = this.state.selectedMonth
    let myDay
    let myMonth
    let myYear
    let start = new Date()
    let end = new Date()
    if (selectedDay) {
      myDay = selectedDay.getDate()
      myMonth = selectedMonth.getMonth()
      myYear = selectedMonth.getFullYear()
      start = new Date(myYear, myMonth, myDay, 0, 0, 0)
      end = new Date(myYear, myMonth, myDay, 23, 59, 59)
    }
    if (selectedDay) {
      let body = getBody(vehicleNumberList, start.toJSON(), end.toJSON())
      fetch(
        `${config.couchdb_final_docs}InProgressByVehicleAndDate/queries`, {
          method: 'post',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then((data) => {
          this.setState({
            dataOfSelectedDay: self.updateDataStructure(resultsToUniqueArray(data.results)),
            selectedDay: selectedDay,
            requirementKey: Math.random()
          })
        })
        .catch(error => { console.log(error) })
    }
  }

  async getTicketToCheckOfSelectedDay (day) {
    const self = this
    let vehicleNumberList = await getVehicleNumberByTrackables(this.getTrackableIds())
    let selectedDay = day
    let selectedMonth = this.state.selectedMonth
    let myDay
    let myMonth
    let myYear
    let start = new Date()
    let end = new Date()
    if (selectedDay) {
      myDay = selectedDay.getDate()
      myMonth = selectedMonth.getMonth()
      myYear = selectedMonth.getFullYear()
      start = new Date(myYear, myMonth, myDay, 0, 0, 0)
      end = new Date(myYear, myMonth, myDay, 23, 59, 59)
    }
    if (selectedDay) {
      let body = getBody(vehicleNumberList, start.toJSON(), end.toJSON())
      fetch(
        `${config.couchdb_final_docs}ToCheckByVehicleAndDate/queries`, {
          method: 'post',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then((data) => {
          this.setState({
            dataOfSelectedDay: self.updateDataStructure(resultsToUniqueArray(data.results)),
            selectedDay: selectedDay,
            requirementKey: Math.random()
          })
        })
        .catch(error => { console.log(error) })
    }
  }

  async getCheckedTicketOfSelectedDay (day) {
    const self = this
    let vehicleNumberList = await getVehicleNumberByTrackables(this.getTrackableIds())
    let selectedDay = day
    let selectedMonth = this.state.selectedMonth
    let myDay
    let myMonth
    let myYear
    let start = new Date()
    let end = new Date()
    if (selectedDay) {
      myDay = selectedDay.getDate()
      myMonth = selectedMonth.getMonth()
      myYear = selectedMonth.getFullYear()
      start = new Date(myYear, myMonth, myDay, 0, 0, 0)
      end = new Date(myYear, myMonth, myDay, 23, 59, 59)
    }
    if (selectedDay) {
      let body = getBody(vehicleNumberList, start.toJSON(), end.toJSON())
      fetch(
        `${config.couchdb_final_docs}CheckedByVehicleAndDate/queries`, {
          method: 'post',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then((data) => {
          this.setState({
            dataOfSelectedDay: self.updateDataStructure(resultsToUniqueArray(data.results)),
            selectedDay: selectedDay,
            requirementKey: Math.random()
          })
        })
        .catch(error => { console.log(error) })
    }
  }

  getDataOfSelectedDay (day, route) {
    const self = this
    switch (route) {
      case 'Ticket':
        self.getAllTicketOfSelectedDay(day)
        break
      case 'InProgress':
        self.getInprogressTicketOfSelectedDay(day)
        break
      case 'CheckTicket':
        self.getTicketToCheckOfSelectedDay(day)
        break
      case 'CheckedTicket':
        self.getCheckedTicketOfSelectedDay(day)
        break
      default:
        self.getAllTicketOfSelectedDay(day)
    }
  }

  async getAllTicketOfSelectedMonth (month) {
    var startMonth = moment([month.getFullYear(), month.getMonth()]).toJSON()
    var endMonth = moment([month.getFullYear(), month.getMonth()]).endOf('month').toJSON()
    var vehicleNumberList = await getVehicleNumberByTrackables(this.getTrackableIds())
    var body = getBody(vehicleNumberList, startMonth, endMonth)
    fetch(
      `${config.couchdb_final_docs}AllByVehicleAndDate/queries`, {
        method: 'post',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((data) => {
        this.setState({
          dataOfMonth: resultsToUniqueArray(data.results)
        })
      })
      .catch(error => { console.log(error) })
  }

  async getInprogressTicketOfSelectedMonth (month) {
    var startMonth = moment([month.getFullYear(), month.getMonth()]).toJSON()
    var endMonth = moment([month.getFullYear(), month.getMonth()]).endOf('month').toJSON()
    var vehicleNumberList = await getVehicleNumberByTrackables(this.getTrackableIds())
    var body = getBody(vehicleNumberList, startMonth, endMonth)
    fetch(
      `${config.couchdb_final_docs}InProgressByVehicleAndDate/queries`, {
        method: 'post',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((data) => {
        this.setState({
          dataOfMonth: resultsToUniqueArray(data.results)
        })
      })
      .catch(error => { console.log(error) })
  }

  async getTicketToCheckOfSelectedMonth (month) {
    var startMonth = moment([month.getFullYear(), month.getMonth()]).toJSON()
    var endMonth = moment([month.getFullYear(), month.getMonth()]).endOf('month').toJSON()
    var vehicleNumberList = await getVehicleNumberByTrackables(this.getTrackableIds())
    var body = getBody(vehicleNumberList, startMonth, endMonth)
    fetch(
      `${config.couchdb_final_docs}ToCheckByVehicleAndDate/queries`, {
        method: 'post',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((data) => {
        this.setState({
          dataOfMonth: resultsToUniqueArray(data.results)
        })
      })
      .catch(error => { console.log(error) })
  }

  async getCheckedTicketOfSelectedMonth (month) {
    var startMonth = moment([month.getFullYear(), month.getMonth()]).toJSON()
    var endMonth = moment([month.getFullYear(), month.getMonth()]).endOf('month').toJSON()
    var vehicleNumberList = await getVehicleNumberByTrackables(this.getTrackableIds())
    var body = getBody(vehicleNumberList, startMonth, endMonth)
    fetch(
      `${config.couchdb_final_docs}CheckedByVehicleAndDate/queries`, {
        method: 'post',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then((data) => {
        this.setState({
          dataOfMonth: resultsToUniqueArray(data.results)
        })
      })
      .catch(error => { console.log(error) })
  }

  getTicketOfSelectedMonth (route, month) {
    const self = this
    switch (route) {
      case 'Ticket':
        self.getAllTicketOfSelectedMonth(month)
        break
      case 'InProgress':
        self.getInprogressTicketOfSelectedMonth(month)
        break
      case 'CheckTicket':
        self.getTicketToCheckOfSelectedMonth(month)
        break
      case 'CheckedTicket':
        self.getCheckedTicketOfSelectedMonth(month)
        break
      default:
        self.getAllTicketOfSelectedMonth(month)
    }
  }

  editTicket (id) {
    const self = this
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (data) {
        if (data.error && data.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        fetch(
          `${config.couchdb_jsonapi}fuel_sensor_ticket/${id}`,
          { headers: { 'Access-Control-Allow-Origin': '*' } }
        )
          .then(response => response.json())
          .then((data) => {
            self.setState({
              dataOfForm: data.data
            })
          })
          .catch(error => { console.log(error) })
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  changeStatusOfTicket (id) {
    const self = this
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (data) {
        if (data.error && data.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        let attributes = {
          state: 'to_check'
        }
        let body = {
          data: {
            type: 'FUEL_SENSOR_TICKET',
            attributes: attributes
          }
        }
        fetch(`${config.couchdb_jsonapi}fuel_sensor_ticket/${id}`, {
          method: 'PUT',
          body: JSON.stringify(body),
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/vnd.api+json'
          }
        }).then(response => {
          response.json()
          self.refreshPage()
        }).catch(error => console.log(error))
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  refreshPage () {
    window.location.reload()
  }

  deleteTicket () {
    const self = this
    var token = localStorage.getItem('token')
    getUserInfo(token)
      .then(response => response.json())
      .then(function (data) {
        if (data.error && data.error.code === 401) {
          refreshToken(localStorage.getItem('refresh_token'))
        }
        let id = self.state.idTicket
        fetch(`${config.couchdb_jsonapi}fuel_sensor_ticket/${id}`, {
          method: 'DELETE',
          headers: {
            'Access-Control-Allow-Origin': '*'
          }
        }).then(() => {
          self.onCloseModal()
          self.refreshPage()
        }).catch(error => console.log(error))
      })
      .catch((error) => {
        console.log('error: ', error)
      })
  }

  onOpenModal (id) {
    this.setState({
      openModal: true,
      idTicket: id
    })
  }

  onCloseModal () {
    this.setState({ openModal: false })
  }

  renderTicketListContent () {
    const self = this
    let selectedDay = self.state.selectedDay
    let myDay
    let start = new Date()
    let end = new Date()
    if (selectedDay) {
      myDay = selectedDay.getDate()
      start.setDate(myDay)
      start.setHours(0, 0, 0, 0)
      end.setDate(myDay)
      end.setHours(23, 59, 59, 999)
    }
    if (selectedDay) {
      return (
        <TicketListContent
          data={self.state.dataOfSelectedDay}
          onClickLeftButton={(id) => self.editTicket(id)}
          onClickButtonCenter={(id) => self.changeStatusOfTicket(id)}
          onClickButtonRight={(id) => self.onOpenModal(id)}
          openModal={self.state.openModal}
          onCloseModal={() => self.onCloseModal()}
          confirmSuppressionTicket={() => self.deleteTicket()}
          keySearch={self.props.keySearch}
        />
      )
    }
    return (
      <TicketListContent
        data={self.state.data}
        onClickLeftButton={(id) => self.editTicket(id)}
        onClickButtonCenter={(id) => self.changeStatusOfTicket(id)}
        onClickButtonRight={(id) => self.onOpenModal(id)}
        openModal={self.state.openModal}
        onCloseModal={() => self.onCloseModal()}
        confirmSuppressionTicket={() => self.deleteTicket()}
        keySearch={self.props.keySearch}
      />
    )
  }

  render () {
    const self = this
    if (this.state.dataOfForm) {
      return <Redirect
        to={{
          pathname: `/${localStorage.getItem('endpoint')}/edit-ticket`,
          state: {
            dataOfForm: this.state.dataOfForm,
            title: 'Modifier un ticket'
          }
        }}
      />
    }
    return (
      <div style={styles.root}>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={12} md={8} lg={9} xl={10}>
            <div key={this.state.requirementKey}>
              {self.renderTicketListContent()}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={4} lg={3} xl={2}>
            { this.state.dataOfMonth
              ? <Calendar
                initialMonth={this.state.selectedMonth}
                onMonthChange={(month) => this.onMonthChange(month)}
                selectedDay={this.state.selectedDay}
                dateList={this.getDateInData(this.state.dataOfMonth)}
                handleDayClick={(day, selected) => this.handleDayClick(day, selected, self.getFormattedDateList(this.state.dataOfMonth))}
              /> : <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
            }
          </Grid>
        </Grid>
      </div>
    )
  }
}

const styles = {
  root: {
    flexGrow: 1,
    marginLeft: '14px',
    marginBottom: '20px'
  }
}

export default TicketContentComponent
